import * as React from "react"
import type { SVGProps } from "react"
export const TextCardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V6.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096m1.808-1.558h11.769a.73.73 0 0 0 .534-.215.73.73 0 0 0 .215-.535.73.73 0 0 0-.215-.534.73.73 0 0 0-.535-.216H6.116a.73.73 0 0 0-.535.216.73.73 0 0 0-.216.534q0 .32.216.535a.73.73 0 0 0 .534.215m0-3.692h11.769a.73.73 0 0 0 .534-.216.73.73 0 0 0 .215-.534.73.73 0 0 0-.215-.534.73.73 0 0 0-.535-.216H6.116a.73.73 0 0 0-.535.216.73.73 0 0 0-.216.534q0 .32.216.534a.73.73 0 0 0 .534.216m0-3.692H14a.73.73 0 0 0 .534-.216.73.73 0 0 0 .216-.534.73.73 0 0 0-.216-.535.73.73 0 0 0-.534-.215H6.116a.73.73 0 0 0-.535.215.73.73 0 0 0-.216.535q0 .319.216.534a.73.73 0 0 0 .534.216"
    ></path>
  </svg>
)
